import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useAuth } from '../../../../../../../context/AuthContext';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";
import GeneralRequestHelper from '../../../../../../../Helpers/GeneralRequestHelper';
import SubmitButton from '../UI/SubmitButton';
import InfoInput from '../UI/InfoInput';
import CorrectAnswer from '../UI/CorrectAnswer';
import QuestionTextInput from '../UI/QuestionTextInput';
import QuestionTitleInput from '../UI/QuestionTitleInput';
import AddContentQuestion from '../UI/AddContentQuestion';
import Tag from '../UI/Tag';
import TitleArea from '../UI/TitleArea';
import AnswerForm from '../UI/AnswerForm';
import { API_BASE_URL } from "../../../../../../../Helpers/apiConfig";

const TrueFalse = (props) => {
    const { user } = useAuth();
    const params = useParams()
    const navigate = useNavigate();
    const [msg, setMsg] = useState([]);
    const [imagePath, setImagePath] = useState(null);
    const [videoPath, setVideoPath] = useState(null);
    const [soundPath, setSoundPath] = useState(null);
    const [serviceList, setServiceList] = useState([{ service: "" }]);
    const [data, setData] = useState([]);

    const handletype5 = async (e) => {
        e.preventDefault();
        var answer = document.getElementById("correctAnswer").value;
        var question;

        let questiontitle = document.getElementById("questionTitle").value;

        let que = document.getElementById("questionText").value;
        let questiontext = questiontitle + "__" + que;

        if (imagePath) {
            question = {
                type: "image",
                url: imagePath,
                text: questiontext
            }
        }
        else if (soundPath) {
            question = {
                type: "sound",
                url: soundPath,
                text: questiontext
            }
        }
        else if (videoPath) {
            question = {
                type: "video",
                url: videoPath,
                text: questiontext
            }
        }
        else {
            question = {
                type: "text",
                url: "",
                text: questiontext
            }
        }
        var stringquestion = JSON.stringify(question)
        var obj = []
        for (let i = 0; i < serviceList.length; i++) {
            let list = {
                id: i,
                service: serviceList[i]['service'],
                photo: serviceList[i]['photo'],
                photourl: serviceList[i]['addphotos'],
                sound: serviceList[i]['sound'],
                soundurl: serviceList[i]['addsounds'],
                video: serviceList[i]['video'],
                videourl: serviceList[i]['addvideos'],
            }
            obj.push(list)
        }
        try {

            var questionn = {
                isDeleted: data.isDeleted,
                tagId: document.getElementById("tagId").value,
                sortId: data.sortId,
                contentType: "truefalse",
                subjectId: params["subject"],
                contentStr: stringquestion,
                detail: JSON.stringify(obj),
                notfyText: document.getElementById("infoBoxText").value,
                answer: answer,
                id: params['sort']
            }
            await GeneralRequestHelper("/api/admin/ContentManager/Update", "post", questionn, user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Soru listesi sayfasına Dön`,
                            timer: 5000,
                        }).then(() => {
                            navigate("/admin/questionlist");
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message)
            setMsg(err.message);
        }
    }
    const getQuestion = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/admin/ContentManager/GetById`;
            await axios({
                method: 'GET',
                url: url,
                headers: headerss,
                params: {
                    id: params["sort"]
                }
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        setData(res.data['data'])
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err?.message || "Bir hata oluştu");
        }
    }
    useEffect(() => {
        getQuestion();
    });
    return (
        <div>
            <TitleArea msg={msg} text={"True/False Oluşturma Sayfası"} />
            <Tag />
            <AddContentQuestion setMsg={setMsg} setImagePath={setImagePath} setVideoPath={setVideoPath} setSoundPath={setSoundPath} />
            <hr />
            <form onSubmit={handletype5} >
                <QuestionTitleInput />
                <QuestionTextInput />
                <CorrectAnswer text="Lütfen küçük harfler ile boşluksuz virgüllü yazınız. örn cevap: true,false,true. cevap ekle kısmında eklenen her soru/ifade nin cevapları şeklinde olmalıdır " />
                <InfoInput />
                <AnswerForm setServiceList={setServiceList} serviceList={serviceList} file={true} />
                <SubmitButton />
            </form>
            <hr />
        </div>
    );
};

export default TrueFalse;